import React, { useEffect, useState } from "react";
import { Row, Col, Typography, DatePicker, message, Button, Icon } from "antd";

import moment from "moment";

import DataRenderer from "./DataRenderer";
import TotalCustomerTillDate from "./TotalCustomerTillDate";
import Releaseanalytics from "./Releaseanalytics";
import DataTable from "./DataTable";
import { Pie } from "@ant-design/plots";
import { Column } from "@ant-design/plots";

import Loader from "../../components/Loader/Loader";

import {
    fetchInaamActivityAnalyticsApi,
    FetchDeviceAnalytics,
    FetchFilteredActivity,
    FetchTodaysActivity,
    exportInaamCustomerApi,
    FetchReleaseAnalytics,
    FetchLoginActivity,
} from "utils/apiService";

const { Text } = Typography;
const { RangePicker } = DatePicker;

export default function CustomerDashboard(props) {
    const [loading, setLoading] = useState(true);
    const [customerDetailsFilterDate, setCustomerDetailsFilterDate] = useState({ start_date: "", end_date: "" });
    const [analyticData, setAnalyticData] = useState({
        filteredAnalytics: null,
        todayAnalytics: null,
        deviceAnalytic: null,
        releaseAnalytics: null,
        loginAnalytics: null,
    });

    const [filterdAnalytics, setFilterdAnalytics] = useState(null);
    const [todayAnalytics, setTodayAnalytics] = useState(null);
    const [deviceAnalytics, setDeviceAnalytics] = useState({
        total_devices: 0,
        ios: 0,
        android: 0,
        ios_versions: [],
        android_versions: [],
    });
    const [releaseAnalytics, setReleaseAnalytics] = useState(null);
    const [loginAnalytics, setLoginAnalytics] = useState([]);

    const exportReport = () => {
        message.loading("Exporting customer details...", 1);
        exportInaamCustomerApi({
            requestData: customerDetailsFilterDate,
            resCallback: () => {
                setLoading(false);
            },
            res200Callback: () => {
                message.success("Customer Details exported successfully.", 1);
            },
            resErrorCallback: () => {
                message.error("Exporting the customer details was unsuccessful!", 1);
            },
        });
    };

    const loadtable = () => {
        FetchTodaysActivity({
            requestData: customerDetailsFilterDate,
            resCallback: () => {},
            res200Callback: (res) => {
                setTodayAnalytics(res?.data?.today_analytics);
            },
            resErrorCallback: () => {},
        });
        FetchDeviceAnalytics({
            requestData: customerDetailsFilterDate,
            resCallback: () => {},
            res200Callback: (res) => {
                setDeviceAnalytics(res?.data?.device_analytics);
            },
            resErrorCallback: () => {},
        });
        FetchLoginActivity({
            requestData: customerDetailsFilterDate,
            resCallback: () => {},
            res200Callback: (res) => {
                // setLoginAnalytics(res?.data?.login_analytics);
                let resData = res?.data?.login_analytics;
                let datearray = [];
                for (const x in resData) {
                    let item = {
                        date: x,
                        count: resData[x],
                    };
                    datearray.push(item);
                }
                setLoginAnalytics(datearray);
            },
            resErrorCallback: () => {},
        });
        // FetchReleaseAnalytics({
        //     requestData: customerDetailsFilterDate,
        //     resCallback: () => {},
        //     res200Callback: (res) => {
        //         setReleaseAnalytics(res?.data?.release_analytics);
        //     },
        //     resErrorCallback: () => {},
        // });
    };

    useEffect(() => {
        loadtable();
        console.log("analyticData: -" + JSON.stringify(analyticData));
        return () => {
            setReleaseAnalytics(null);
            setDeviceAnalytics(null);
            setLoginAnalytics(null);
            setTodayAnalytics(null);
            setFilterdAnalytics(null);
        };
    }, []);

    useEffect(() => {
        // fetchInaamActivityAnalytics();
        FetchFilteredActivity({
            requestData: customerDetailsFilterDate,
            resCallback: () => {},
            res200Callback: (res) => {
                setFilterdAnalytics(res?.data?.filtered_analytics);
                setLoading(false);
            },
            resErrorCallback: () => {},
        });
    }, [customerDetailsFilterDate]);

    return loading ? (
        <div
            style={{
                minHeight: "100vh",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                backgroundColor: "#FAFAFA",
            }}>
            <Loader />
        </div>
    ) : (
        <>
            <Row
                style={{
                    width: "100%",
                    padding: "40px 25px 0",
                    margin: "60px auto 0",
                    backgroundColor: "#FAFAFA",
                }}
                gutter={[12, 48]}>
                <Row type='flex' align='middle' justify='space-between'>
                    <Text
                        style={{
                            color: "#181818",
                            /*fontFamily: "Gotham",*/ fontStyle: "normal",
                            fontWeight: "bold",
                            fontSize: "24px",
                            lineHeight: "39px",
                        }}>
                        Customer Dashboard
                    </Text>
                </Row>

                <Col span={24}>
                    <DataRenderer data={todayAnalytics} loading={loading} />
                </Col>
                <Col span={24}>
                    <TotalCustomerTillDate
                        data={filterdAnalytics}
                        loading={loading}
                        customerDetailsFilterDate={customerDetailsFilterDate}
                        setCustomerDetailsFilterDate={setCustomerDetailsFilterDate}
                    />
                </Col>
                {/* <Col span={24}>
                    <Releaseanalytics
                        data={releaseAnalytics}
                        loading={loading}
                        customerDetailsFilterDate={customerDetailsFilterDate}
                    />
                </Col> */}
                <Col span={24}>
                    <Col span={16}>{loginAnalytics?.length > 0 ? <GraphData data={loginAnalytics} /> : <></>}</Col>
                    <Col span={8}>{deviceAnalytics ? <PieGraphData appdata={deviceAnalytics} /> : <></>}</Col>
                </Col>
            </Row>
        </>
    );
}

const GraphData = (props) => {
    const { data } = props;

    const config = {
        data,
        xField: "date",
        yField: "count",
        xAxis: {
            label: {
                autoRotate: false,
            },
        },
        slider: {
            start: 0.1,
            end: 0.4,
        },
        color: "#fec708",
    };
    return (
        <div style={{ display: "flex", flexDirection: "column" }}>
            <div
                style={{
                    fontWeight: "bold",
                    color: " #181818",
                    fontSize: "18px",
                    lineHeight: "24px",
                    marginBottom: "16px",
                }}>
                {" "}
                Login Activity
            </div>
            <Column
                {...config}
                style={{ width: "100%", backgroundColor: "#ffffff", marginRight: "16px", padding: "8px 16px" }}
            />
        </div>
    );
};

const PieGraphData = (props) => {
    const { appdata } = props;

    const data = [
        {
            type: "Andriod",
            value: appdata?.android,
        },
        {
            type: "IOS",
            value: appdata?.ios,
        },
        {
            type: "Other",
            value: appdata?.total_devices - appdata?.android - appdata?.ios,
        },
    ];

    const config = {
        appendPadding: 10,
        data,
        angleField: "value",
        colorField: "type",
        radius: 1,
        innerRadius: 0.6,
        label: {
            type: "inner",
            offset: "-50%",
            content: "{value}",
            style: {
                textAlign: "center",
                fontSize: 14,
            },
        },
        theme: {
            colors10: ["#fec708", "#e3102f", "#838587", "#D9DBE9"],
        },
        interactions: [
            {
                type: "element-selected",
            },
            {
                type: "element-active",
            },
        ],
        statistic: {
            title: false,
            content: {
                style: {
                    whiteSpace: "pre-wrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    fontSize: "22px",
                    opacity: "60%",
                },
                content: "Total Customer \n" + appdata?.total_devices,
                // content: `${<span style={{opacity:"60%"}}>Total Devices <span style={{fontSize:"32px" , fontWeight:"bold"}}>{appdata?.total_devices}</span></span>}`,
                // content: <span style={{opacity:"60%"}}>Total Devices <span style={{fontSize:"32px" , fontWeight:"bold"}}>{appdata?.total_devices}</span></span>,
            },
        },
    };
    return (
        <div style={{ display: "flex", flexDirection: "column" }}>
            <div
                style={{
                    alignSelf: "center",
                    fontWeight: "bold",
                    color: " #181818",
                    fontSize: "18px",
                    lineHeight: "24px",
                    marginBottom: "16px",
                }}>
                Device Analytics
            </div>
            <Pie {...config} />
        </div>
    );
};
